import Form from 'components/form/Form';
import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
export default class GiftWrap extends Component {
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            form: ['.form', Form]
        };
    }
    bindEvents(add) {
        const method = bindMethod(add);
        this?.refs.input?.[method]('change', this.onInputChange.bind(this));
    }
    onInputChange() {
        this?.modules?.form?.submit();
    }
}
